import { isEmpty } from "lodash";
import { getDaysInMonth } from "../helpers";

const createEmptyRule = () => ({
  startTime: "",
  endTime: "",
  week_days: [],
  month_days: [],
  months: [],
});

const sortFunction = (a, b) => a - b;

export default (rulesArray, scheduleName) => {
  /**
   * @param {Array} rulesArray an array of rules.
   * @param {String} scheduleName the name corresponding to the set of rules.
   * @returns <{scheduleName: string, rules: Array<{.., months: [], month_days[]}>}>}
   */

  const schedule = {
    scheduleName,
    rules: [],
  };

  if (isEmpty(rulesArray)) return schedule;

  const rules = [];

  if (rulesArray.length === 1) {
    rules.push(rulesArray[0]);
  }
  if (rulesArray.length > 1) {
    rules.push(rulesArray[0]);

    const lastRule = rulesArray[rulesArray.length - 1];
    for (let i = 1; i < rulesArray.length - 1; i++) {
      const currentRule = rules[rules.length - 1];
      const nextRule = rulesArray[i];

      let currentRuleMonthLength;
      if (currentRule.months[0] === rules[0].months[0]) {
        currentRuleMonthLength =
          getDaysInMonth(currentRule.months[0]) - (currentRule.month_days.length + 1);
      } else {
        currentRuleMonthLength =
          getDaysInMonth(currentRule.months[0]) - currentRule.month_days.length;
      }

      const nextRuleMonthLength = getDaysInMonth(nextRule.months[0]) - nextRule.month_days.length;

      if (
        currentRule.startTime === nextRule.startTime &&
        currentRule.endTime === nextRule.endTime &&
        currentRuleMonthLength === nextRuleMonthLength
      ) {
        currentRule.startTime = nextRule.startTime;
        currentRule.endTime = nextRule.endTime;
        currentRule.month_days = [
          ...new Set([...currentRule.month_days, ...nextRule.month_days]),
        ].sort(sortFunction);
        currentRule.months = [...new Set([...currentRule.months, ...nextRule.months])];
      } else {
        const newRule = createEmptyRule();
        newRule.startTime = nextRule.startTime;
        newRule.endTime = nextRule.endTime;
        newRule.month_days = nextRule.month_days;
        newRule.months = nextRule.months;
        rules.push(newRule);
      }
    }
    rules.push(lastRule);
  }

  return {
    scheduleName,
    rules,
  };
};
